<script>
import {
  ExchangePriceWidgetInlineClicked,
  ExchangePriceWidgetFloatClicked,
  LogExchangePriceStep1Shown,
  LogExchangePriceStep1RegistrationNumberIncluded,
  LogExchangePriceStep2Shown,
  LogExchangePriceStep3Shown,
  LogExchangePriceStep4Shown,
  LogExchangePriceStep5Shown,
  LogExchangePriceStep5PriceFound,
} from '@/events'

export default {
  template: '<template></template>',
  methods: {
    eventHandler(event) {
      if (
        window.CookieInformation === undefined ||
        !window.CookieInformation.getConsentGivenFor('cookie_cat_statistic')
      )
        return

      if (event?.data?.namespace === undefined || event.data.namespace !== 'bt')
        return
      if (event.data.data === undefined) return

      const data = event.data.data
      if (data.event === 'exchangePriceWidget-shown') {
        switch (data.eventAction) {
          case 'step1':
            LogExchangePriceStep1Shown()
            break
          case 'step1 withInitialRegistrationNumber':
            LogExchangePriceStep1RegistrationNumberIncluded()
            break
          case 'step2':
            LogExchangePriceStep2Shown()
            break
          case 'step3':
            LogExchangePriceStep3Shown()
            break
          case 'step4':
            LogExchangePriceStep4Shown()
            break
          case 'step5':
            LogExchangePriceStep5Shown()
            break
          case 'step5 priceFound':
            LogExchangePriceStep5PriceFound()
            break
        }
      }
    },
  },
  mounted() {
    // waiting for exchange price to load
    const inlineButton = document.querySelector('.exchange-price')

    if (inlineButton) {
      inlineButton.addEventListener('click', ExchangePriceWidgetInlineClicked)
    }

    setTimeout(() => {
      const floatButton = document.querySelector(
        '.btWidgetPopup__container--input button'
      )
      if (floatButton) {
        floatButton.addEventListener('click', ExchangePriceWidgetFloatClicked)
      }
    }, 7100)

    window.addEventListener('message', this.eventHandler, true)
  },
}
</script>

<style lang="scss">
@import 'ExchangePrice.scss';
</style>
